export const LOCALE = {
  SET: "LOCALE_SET",
  LOAD: "LOCALE_LOAD",
  REQUEST: "LOCALE_REQUEST",
  RECEIVE: "LOCALE_RECEIVE",
  FAILURE: "LOCALE_FAILURE"
};
